import { useState, useEffect } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

const fmtDate = d => d ? new Date(d).toLocaleDateString('en-PK',{day:'numeric',month:'short',year:'numeric'}) : '—';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');
  .tfr * { box-sizing:border-box; }
  .tfr { font-family:'Sora',sans-serif; color:#1a1d2e; animation:tfrFade .4s ease both; }
  @keyframes tfrFade { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
  .tfr-hdr { margin-bottom:1.5rem; }
  .tfr-title { font-size:1.35rem; font-weight:700; color:#0f1123; letter-spacing:-.02em; }
  .tfr-sub   { font-size:.76rem; color:#9094a8; margin-top:3px; }
  .anon-banner { background:#f0fdf4; border:1px solid #a7f3d0; border-radius:12px; padding:12px 16px; font-size:.78rem; color:#065f46; margin-bottom:1.4rem; }
  .forms-list { display:flex; flex-direction:column; gap:8px; }
  .form-item { background:white; border-radius:14px; border:1px solid #e8ebf4; padding:14px 18px; display:flex; align-items:center; gap:12px; cursor:pointer; transition:.15s; }
  .form-item:hover { border-color:#10c98e; box-shadow:0 4px 14px rgba(16,201,142,.1); }
  .fi-info { flex:1; }
  .fi-title { font-size:.86rem; font-weight:700; color:#0f1123; }
  .fi-meta  { font-size:.72rem; color:#9094a8; margin-top:2px; }
  .fi-sent  { font-size:.68rem; color:#10c98e; font-weight:600; margin-top:2px; }
  .fi-count { font-family:'JetBrains Mono',monospace; font-size:.76rem; font-weight:600; color:#10c98e; background:#ecfdf5; padding:3px 10px; border-radius:99px; flex-shrink:0; }
  /* Results page */
  .results-back { display:inline-flex; align-items:center; gap:6px; font-size:.78rem; font-weight:600; color:#6b7194; cursor:pointer; margin-bottom:1.2rem; }
  .results-back:hover { color:#10c98e; }
  /* Overall score card */
  .score-card { background:white; border-radius:16px; border:1px solid #e8ebf4; padding:1.2rem 1.4rem; margin-bottom:1.4rem; display:flex; align-items:center; gap:16px; flex-wrap:wrap; }
  .score-ring { display:flex; align-items:center; justify-content:center; width:64px; height:64px; border-radius:50%; border:4px solid; font-size:1.1rem; font-weight:700; font-family:'JetBrains Mono',monospace; flex-shrink:0; }
  .score-info { flex:1; }
  .score-label { font-size:.9rem; font-weight:700; color:#0f1123; }
  .score-sub   { font-size:.74rem; color:#9094a8; margin-top:3px; }
  /* Eval type tabs */
  .eval-tabs { display:flex; gap:6px; margin-bottom:1.2rem; flex-wrap:wrap; }
  .eval-tab { padding:7px 16px; border-radius:99px; border:1.5px solid #e0e4f0; font-family:'Sora',sans-serif; font-size:.76rem; font-weight:600; cursor:pointer; background:white; color:#6b7194; transition:.15s; }
  .eval-tab.active-subject      { background:#eef2ff; color:#3b6ef8; border-color:#3b6ef8; }
  .eval-tab.active-class_teacher{ background:#f0fdfa; color:#0d9488; border-color:#0d9488; }
  /* Question block */
  .group-card { background:white; border-radius:14px; border:1px solid #e8ebf4; padding:1.2rem; margin-bottom:1rem; }
  .q-block { margin-bottom:14px; padding-bottom:14px; border-bottom:1px solid #f3f5fb; }
  .q-block:last-child { border-bottom:none; margin-bottom:0; padding-bottom:0; }
  .q-text { font-size:.82rem; font-weight:600; color:#0f1123; margin-bottom:8px; line-height:1.5; }
  .improve-tag { display:inline-flex; font-size:.66rem; font-weight:700; padding:2px 8px; border-radius:99px; background:#fef2f2; color:#ef4444; margin-left:6px; }
  .good-tag    { display:inline-flex; font-size:.66rem; font-weight:700; padding:2px 8px; border-radius:99px; background:#ecfdf5; color:#10c98e; margin-left:6px; }
  /* Rating chart */
  .rating-wrap { display:flex; align-items:flex-start; gap:16px; flex-wrap:wrap; }
  .avg-block { text-align:center; flex-shrink:0; }
  .avg-num   { font-size:2rem; font-weight:700; font-family:'JetBrains Mono',monospace; line-height:1; }
  .avg-label { font-size:.66rem; color:#9094a8; margin-top:3px; font-weight:600; }
  .stars-row { display:flex; gap:2px; justify-content:center; margin-top:4px; }
  .resp-label{ font-size:.68rem; color:#9094a8; margin-top:3px; }
  .rating-bars { flex:1; min-width:160px; }
  .rb-row { display:flex; align-items:center; gap:6px; margin-bottom:3px; }
  .rb-label { width:14px; font-size:.68rem; color:#9094a8; font-family:'JetBrains Mono',monospace; text-align:right; flex-shrink:0; }
  .rb-track { flex:1; height:10px; background:#f0f2f8; border-radius:99px; overflow:hidden; }
  .rb-fill  { height:100%; border-radius:99px; transition:width .5s ease; }
  .rb-count { width:22px; font-size:.66rem; color:#9094a8; font-family:'JetBrains Mono',monospace; flex-shrink:0; }
  /* Yes/No */
  .yn-display { display:flex; gap:10px; align-items:center; flex-wrap:wrap; }
  .yn-bar-wrap { flex:1; min-width:120px; }
  .yn-row { display:flex; align-items:center; gap:6px; margin-bottom:4px; font-size:.74rem; }
  .yn-label { width:28px; font-weight:700; }
  .yn-yes-label{color:#10c98e;} .yn-no-label{color:#ef4444;}
  .yn-track { flex:1; height:8px; background:#f0f2f8; border-radius:99px; overflow:hidden; }
  .yn-fill-yes{height:100%;background:#10c98e;border-radius:99px;transition:width .5s;}
  .yn-fill-no {height:100%;background:#ef4444;border-radius:99px;transition:width .5s;}
  .yn-count { width:24px; font-size:.68rem; color:#9094a8; font-family:'JetBrains Mono',monospace; }
  /* Comments */
  .comments { display:flex; flex-direction:column; gap:5px; }
  .comment { background:#f8f9fc; border:1px solid #e8ebf4; border-radius:8px; padding:8px 12px; font-size:.76rem; color:#1a1d2e; font-style:italic; line-height:1.5; }
  .tfr-empty { text-align:center; padding:3rem 2rem; color:#9094a8; font-size:.82rem; background:white; border-radius:16px; border:1px solid #e8ebf4; }
  .tfr-loading { display:flex; align-items:center; justify-content:center; height:200px; gap:10px; color:#9094a8; }
  .spinner { width:18px; height:18px; border:2px solid #e4e7f0; border-top-color:#10c98e; border-radius:50%; animation:spin .7s linear infinite; }
  @keyframes spin { to{transform:rotate(360deg)} }
  @media (max-width:600px) { .tfr-title{font-size:1.1rem;} .rating-wrap{flex-direction:column;} }
`;

const StarSVG = ({ filled }) => (
  <svg width="14" height="14" viewBox="0 0 24 24">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={filled?'#f59e0b':'#e0e4f0'} stroke="none"/>
  </svg>
);
const Stars = ({ rating }) => <div className="stars-row">{[1,2,3,4,5].map(i=><StarSVG key={i} filled={i<=Math.round(rating)}/>)}</div>;
const scoreColor = avg => avg>=4?'#10c98e':avg>=3?'#f59e0b':'#ef4444';

const RatingChart = ({ agg, color }) => {
  if (!agg || agg.avg==null) return <div style={{fontSize:'.74rem',color:'#c0c5dc'}}>No responses yet</div>;
  return (
    <div className="rating-wrap">
      <div className="avg-block">
        <div className="avg-num" style={{color}}>{agg.avg}</div>
        <Stars rating={agg.avg}/>
        <div className="avg-label">/ 5.0</div>
        <div className="resp-label">{agg.count} resp.</div>
      </div>
      <div className="rating-bars">
        {[5,4,3,2,1].map(star => {
          const count=agg.distribution?.[star]||0, pct=agg.count>0?(count/agg.count)*100:0;
          return (
            <div key={star} className="rb-row">
              <span className="rb-label">{star}</span>
              <div className="rb-track"><div className="rb-fill" style={{width:`${pct}%`,background:star>=4?'#10c98e':star===3?'#f59e0b':'#ef4444'}}/></div>
              <span className="rb-count">{count}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default function TeacherFeedbackResults() {
  const [forms,      setForms]      = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [results,    setResults]    = useState(null);
  const [activeTab,  setActiveTab]  = useState('subject');
  const [resLoading, setResLoading] = useState(false);

  useEffect(() => {
    api.get('/teacher/feedback')
      .then(r => setForms(r.data||[]))
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  const openResults = async (formId) => {
    setResLoading(true);
    try {
      const { data } = await api.get(`/teacher/feedback/${formId}/results`);
      setResults(data);
      // Default to first available tab
      const firstGroup = data.groups?.[0];
      if (firstGroup) setActiveTab(firstGroup.evalType);
    } catch { toast.error('Failed to load results'); }
    finally { setResLoading(false); }
  };

  // Compute overall avg for a set of questions
  const overallAvg = (groups, evalType, questions) => {
    const group = groups.find(g => g.evalType === evalType);
    if (!group) return null;
    const ratings = questions.filter(q=>q.type==='rating').map(q => {
      const agg = group.questions.find(r => r.question._id?.toString()===q._id?.toString());
      return agg?.aggregated?.avg;
    }).filter(v => v != null);
    return ratings.length ? Math.round((ratings.reduce((s,r)=>s+r,0)/ratings.length)*10)/10 : null;
  };

  const hasSubject     = results?.groups?.some(g => g.evalType==='subject');
  const hasClassTeacher= results?.groups?.some(g => g.evalType==='class_teacher');
  const activeGroup    = results?.groups?.find(g => g.evalType===activeTab);
  const subjectAvg     = hasSubject      ? overallAvg(results.groups,'subject',      results.groups.find(g=>g.evalType==='subject')?.questions?.map(q=>q.question)||[]) : null;
  const ctAvg          = hasClassTeacher ? overallAvg(results.groups,'class_teacher',results.groups.find(g=>g.evalType==='class_teacher')?.questions?.map(q=>q.question)||[]) : null;
  const displayAvg     = activeTab==='subject' ? subjectAvg : ctAvg;

  if (results) return (
    <div className="tfr"><style>{css}</style>
      <div className="tfr-hdr">
        <div className="tfr-title">My Feedback Results</div>
        <div className="tfr-sub">{results.formTitle} · {results.academicYear}</div>
      </div>
      <div className="anon-banner">🔒 All results are anonymized. You see averages and counts only — never individual student responses.</div>
      <div className="results-back" onClick={()=>setResults(null)}>← Back to campaigns</div>

      {/* Overall score card */}
      {displayAvg != null && (
        <div className="score-card">
          <div className="score-ring" style={{borderColor:scoreColor(displayAvg),color:scoreColor(displayAvg)}}>{displayAvg}</div>
          <div className="score-info">
            <div className="score-label">Overall {activeTab==='class_teacher'?'Class Teacher':'Subject'} Score</div>
            <div className="score-sub">
              {displayAvg>=4?'Excellent — Keep it up!':displayAvg>=3?'Good — Some areas to improve':displayAvg>=2?'Fair — Needs improvement':'Needs significant improvement'}
            </div>
            <Stars rating={displayAvg}/>
          </div>
          <div style={{fontSize:'.76rem',color:'#9094a8',textAlign:'right'}}>
            <div style={{fontFamily:"'JetBrains Mono',monospace",fontWeight:700,color:'#0f1123',fontSize:'1.1rem'}}>{results.totalResponses}</div>
            <div>total responses</div>
          </div>
        </div>
      )}

      {/* Subject / Class Teacher tabs */}
      {(hasSubject && hasClassTeacher) && (
        <div className="eval-tabs">
          <button className={`eval-tab${activeTab==='class_teacher'?' active-class_teacher':''}`} onClick={()=>setActiveTab('class_teacher')}>
            🏠 Class Teacher Evaluation {ctAvg!=null&&`· ${ctAvg}/5`}
          </button>
          <button className={`eval-tab${activeTab==='subject'?' active-subject':''}`} onClick={()=>setActiveTab('subject')}>
            📚 Subject Evaluation {subjectAvg!=null&&`· ${subjectAvg}/5`}
          </button>
        </div>
      )}
      {hasSubject && !hasClassTeacher && <div style={{fontSize:'.76rem',fontWeight:600,color:'#3b6ef8',marginBottom:12}}>📚 Subject Evaluation — {activeGroup?.subject}</div>}
      {hasClassTeacher && !hasSubject  && <div style={{fontSize:'.76rem',fontWeight:600,color:'#0d9488',marginBottom:12}}>🏠 Class Teacher Evaluation</div>}

      {activeGroup && (
        <div className="group-card">
          {activeGroup.questions.map(({ question: q, aggregated: agg }) => {
            const isLow  = q.type==='rating' && agg.avg!=null && agg.avg<3;
            const isGood = q.type==='rating' && agg.avg!=null && agg.avg>=4;
            const color  = activeTab==='class_teacher'?'#0d9488':'#3b6ef8';
            return (
              <div key={q._id} className="q-block">
                <div className="q-text">
                  {q.text}
                  {isLow  && <span className="improve-tag">⚠ Needs Improvement</span>}
                  {isGood && <span className="good-tag">✓ Good</span>}
                </div>
                {q.type==='rating' && <RatingChart agg={agg} color={color}/>}
                {q.type==='yes_no' && (
                  <div className="yn-display">
                    <div className="yn-bar-wrap">
                      <div className="yn-row"><span className="yn-label yn-yes-label">Yes</span><div className="yn-track"><div className="yn-fill-yes" style={{width:agg.count>0?`${(agg.yes/agg.count)*100}%`:'0%'}}/></div><span className="yn-count">{agg.yes}</span></div>
                      <div className="yn-row"><span className="yn-label yn-no-label">No</span><div className="yn-track"><div className="yn-fill-no"  style={{width:agg.count>0?`${(agg.no/agg.count)*100}%`:'0%'}}/></div><span className="yn-count">{agg.no}</span></div>
                    </div>
                    <span style={{fontSize:'.72rem',color:'#9094a8'}}>({agg.count} resp.)</span>
                  </div>
                )}
                {q.type==='text' && (
                  <div className="comments">
                    {agg.comments?.length>0 ? agg.comments.map((t,i)=><div key={i} className="comment">"{t}"</div>) : <div style={{fontSize:'.74rem',color:'#c0c5dc'}}>No comments</div>}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

  return (
    <div className="tfr"><style>{css}</style>
      <div className="tfr-hdr">
        <div className="tfr-title">My Feedback Results</div>
        <div className="tfr-sub">View evaluations sent to you by admin — fully anonymized</div>
      </div>
      <div className="anon-banner">🔒 All results are anonymized. You see averages and counts only — never who said what.</div>
      {loading ? (
        <div className="tfr-loading"><div className="spinner"/>Loading…</div>
      ) : forms.length===0 ? (
        <div className="tfr-empty">No feedback results have been shared with you yet. Admin will send results after reviewing them.</div>
      ) : (
        <div className="forms-list">
          {forms.map(f => (
            <div key={f._id} className="form-item" onClick={()=>openResults(f._id)}>
              <div className="fi-info">
                <div className="fi-title">{f.title}</div>
                <div className="fi-meta">{f.academicYear} · {f.status}</div>
                {f.sentAt && <div className="fi-sent">✓ Shared by admin on {fmtDate(f.sentAt)}</div>}
              </div>
              <span className="fi-count">{f.responseCount} response{f.responseCount!==1?'s':''}</span>
              <ChevronRightIcon style={{width:16,height:16,stroke:'#9094a8',strokeWidth:2,flexShrink:0}}/>
            </div>
          ))}
        </div>
      )}
      {resLoading && <div className="tfr-loading"><div className="spinner"/>Loading results…</div>}
    </div>
  );
}